<lxm-dialog [dialogRef]="dialogRef" [formGroup]="formGroup">
  <span header-title>{{ 'cards.products.send_product_images_dialog.title' | translate }}</span>

  <div body>
    <!-- <p class="mb30 mt15 font-text text-sm font-normal text-dirtyPurple"
      [innerHTML]="'cards.products.send_product_images_dialog.info_text' | translate">
    </p> -->

    <div class="row">
      <div class="col-12 no-padding">
        <form-field dialog for="recipients" label="cards.products.conformity_declaration_dialog.label.recipients">
          <lxm-select for="recipients"
            [options]="contactOptions"  
            groupBy="companyName"
            labelField="value"
            additionalField="companyName"
            class="w-full"
            [multiple]="true"
            [searchable]="true"
            [addTag]="addNewRecipient"
            [addTagText]="'components.select.add_new_recipient' | translate">
          </lxm-select>
          <validation-errors for="recipients"></validation-errors>
        </form-field>

        <form-field dialog for="comment" type="textarea" maxlength="3000"
          label="cards.products.send_product_images_dialog.label.comment"
          description="cards.products.send_product_images_dialog.description.comment">
          <validation-errors for="comment"></validation-errors>
        </form-field>

        <form-field dialog label="cards.products.send_product_images_dialog.label.is_master_only"
          description="cards.products.send_product_images_dialog.description.is_master_only">
          <slide-toggle toggle for="isMasterOnly">
          </slide-toggle>
          <validation-errors for="isMasterOnly"></validation-errors>
        </form-field>

        <!-- <card-message *ngIf="showTooManyProductsWarning" class="mt10" type="warning"
          [html]="'cards.products.conformity_declaration_dialog.too_many_products_warning_text' | translate">
        </card-message> -->
      </div>
    </div>
  </div>

  <section footer>
    <lxm-button type="primary" label="action.send" [loading]="actionLoading.send" (click)="send()"></lxm-button>
    <lxm-button type="tertiary" label="action.cancel" (click)="closeDialog()"></lxm-button>
  </section>
</lxm-dialog>